<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :width="width"
    :before-close="handleClose"
    @open="handleOpened"
  >
    <div slot="title">
      <span>导出列表</span>
      <el-tooltip class="item" placement="right-start" v-if="tooltipStatus">
        <ol slot="content">
          <li>导出的数据在线保存一个月，支持重复下载</li>
          <li>
            导出的数据超出一个月后，建议重新点击【导出数据】选择对应的数据进行导出
          </li>
        </ol>
        <i class="el-icon-info"></i>
      </el-tooltip>
    </div>

    <!-- 列表 -->
    <QS-common-table
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :pagination="paginationData"
      @change="paginationChange"
    >
    </QS-common-table>
  </el-dialog>
</template>

<script>
import config from './config/index.js'
import { getExportList } from './api.js'
import * as exportApi from '@/api/export'

export default {
  name: 'ExportDialogList',
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '824px',
    },
    filename: {
      type: String,
      default: '逾期明细表',
    },
    tooltipStatus: {
      type: Boolean,
      default: true,
    },
    // eslint-disable-next-line vue/no-unused-properties
    taskType: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    const { columns } = config.call(this, this.filename)
    return {
      columns,
      exportByColumnLoading: false,
      exportTemplate: 'DownloadFile',
      tableData: [],
      loading: false,
      paginationData: {
        // 分页
        pageNum: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
    }
  },
  methods: {
    // 同步导出Excel
    // eslint-disable-next-line vue/no-unused-properties
    exportHandle(row) {
      if (row.taskStatus === 1) {
        this.$message.error('进行中的任务不能下载')
        return
      }
      if (this.exportByColumnLoading) return false
      this.exportByColumnLoading = true
      const exportTemplate =
        this.exportTemplate.substr(0, 1).toUpperCase() +
        this.exportTemplate.substr(1)
      exportApi[`export${exportTemplate}`]({
        taskId: row.taskId,
      })
        .then((data) => {
          if (data) {
            const url = window.URL.createObjectURL(
              new Blob([data], {
                type:
                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              }),
            )
            const link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', row.fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .finally(() => {
          this.exportByColumnLoading = false
        })
    },
    handleOpened() {
      console.log('handleOpened')
      this.getList()
    },
    handleClose() {
      this.$emit('update:dialogVisible', false)
    },
    // 切换页码
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getList()
    },
    // 获取表格列表数据
    async getList() {
      try {
        const params = {
          taskType: this.taskType,
          pageSize: this.paginationData.pageSize,
          pageNum: this.paginationData.pageNum,
        }

        this.oLoading = true
        const { code, data } = await getExportList(params)
        this.oLoading = false
        if (code === 1) {
          this.tableData = (data && data.items) || []
          this.paginationData.total = data.totalNum
        }
      } catch (error) {
        this.oLoading = false
      }
    },
  },
}
</script>
